import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsBlogText {
    export const componentId = 'blog-text';

    export interface IComponentData extends NICmsContentComponent.IData {
        align?: string;
        title?: string;
        subtitle?: string;
        copy: string;
    }
}

@ICmsComponent<CmsBlogComponentTextComponent>({
    id: NCmsBlogText.componentId,
    name: 'Blog Text',
    tags: ['Blog', 'Text'],
    isAdvanced: true,
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Alignment',
            options: [
                { key: 'left', title: 'Left' },
                { key: 'center', title: 'Center' }
            ],
            default: 'center'
        },
        {
            key: 'title',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Title'
        },
        {
            key: 'subtitle',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Subtitle'
        },
        {
            key: 'copy',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy',
            default: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            required: true
        }
    ],
    priority: 20
})
@Component({
    selector: 'cms-blog-component-text',
    templateUrl: './cms-blog-component-text.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentTextComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsBlogText.IComponentData;
}
